import { createApiAction } from '@app/packages/api/utils'
import type { V3PostParticipantsResolveResponse } from '@app/packages/api/v3/types/responses'

/**
 * Resolve chat_server participant external_ids (each a user's `chat_server_uid`,
 * `admin:<uuid>`, `bot:<name>`, …) to display name/avatar.
 */
export const postParticipantsResolve = (externalIds: string[]) =>
  createApiAction('postParticipantsResolve', dispatch =>
    dispatch<V3PostParticipantsResolveResponse>({
      endpoint: '/api/v3/participants/resolve',
      method: 'POST',
      body: JSON.stringify({ external_ids: externalIds }),
    })
  )
